/**
 * Barre de navigation pour la section Administration.
 * Affiche des onglets : Utilisateurs, Squads, Practices.
 */

import React from "react";
import { Link, useLocation } from "react-router-dom";
import "../pages/PageStyles.css";

export default function AdminNav() {
  const location = useLocation();
  const path = location.pathname;

  return (
    <div className="admin-tabs">
      <Link
        to="/admin/users"
        className={`admin-tab ${path.startsWith("/admin/users") ? "active" : ""}`}
      >
        Utilisateurs
      </Link>
      <Link
        to="/admin/squads"
        className={`admin-tab ${path === "/admin/squads" ? "active" : ""}`}
      >
        Squads
      </Link>
      <Link
        to="/admin/practices"
        className={`admin-tab ${path === "/admin/practices" ? "active" : ""}`}
      >
        Practices
      </Link>
    </div>
  );
}
